var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"mb-3 mt-3"},[_c('b-col',{attrs:{"cols":"12"}},[_c('div',{staticClass:"div-separator-prev mb-3 mt-3"})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }